<template>
  <div>
    <!-- -->
    <div class="item-with-submenu">
      <a class="button submenu-trigger" title="Add">
        <div class="icon plus medium"></div>
      </a>
      <div class="submenu">
        <div class="button" v-on:click="goto('/account/player/new')">Add player</div>
        <div class="button" v-on:click="goto('/account/artwork/new')">New artwork</div>
      </div>
    </div>
  </div>
</template>

<script>
import SubmenuMixin from '../../../mixins/submenu'

export default {
  name: 'HeaderUserPlusMenu',
  mixins: [SubmenuMixin('submenu', 'submenu-trigger')],

  methods: {
    goto (path) {
      this.closeSubmenus()
      this.$router.push(path)
    }
  }
}
</script>
